export default {
  state: {
    title: "",
    body: "",
    open: false,
  },

  mutations: {
    setBody(state, body) {
      state.body = body;
    },

    setTitle(state, title) {
      state.title = title;
    },

    openModal(state, title) {
      state.open = true;
    },

    closeModal(state, title) {
      state.open = false;
    },
  },

  actions: {
    setBody({ commit }, body) {
      commit('setBody', body);
    },

    setTitle({ commit }, title) {
      commit('setTitle', title);
    },
  },
};
